import { QuestionAnswer } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { useState } from 'react';
import ModalContainer from '../../../components/ModalContainer';
import { Formik, Form } from 'formik';
import GetField from '../../../components/GetField';
import * as Yup from "yup";
import Alert from '../../../utils/Alert';
import { addManagerDescription } from '../../../services/servicesServices';

const ManagerDetail = ({ rowData, iO }) => { 
// iO means who am I going to see the details, the manager or the contractor
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = async () => {
        setOpen(false);
    };
    const initialValues = {
        manager_description: rowData.manager_description || ""
    }

    const validationSchema = Yup.object().shape({
        manager_description: Yup.string().required("لطفا توضیحات را وارد کنید")
    });

    const onSubmit = async (values) => {
        try {
            const response = await addManagerDescription(rowData.code, values);
            if (response.status === 200) {
                handleClose();
                window.location.reload();
            }
        }catch (error) {
            Alert("خطا!", "در افزودن توضیحات مدیر پروژه مشکلی پیش آمده", "error");
        }
    }

    return (
        <>
        <span>
            <IconButton
            sx={{ mx: "0.25rem" }}
            onClick={handleOpen}
            >
                <QuestionAnswer className="text-green-500" />
            </IconButton>
        </span>
        <ModalContainer
            alwaysOpen={false}
            onClose={handleClose}
            isOpen={open}
            fullscreen={false}
            title={"توضیحات"}
        >
            {iO === "m" ? (
                    <Formik
                        initialValues={initialValues}
                        onSubmit={(values) => onSubmit(values)}
                        validationSchema={validationSchema}
                        validateOnMount
                    >
                        {(formik) => {
                            return (
                                <Form className='flex flex-col items-center'>
                                    <div className='mb-5 w-full md:w-3/5 max-w-screen-sm'>
                                        <GetField
                                            control="textarea"
                                            name="manager_description"
                                            placeholder="توضیحات مدیر پروژه"
                                            label="توضیحات مدیر پروژه:"
                                            rows={5}
                                        />
                                    </div>
                                    <div className='w-full text-center mt-4'>
                                        <GetField
                                            control="submitbutton"
                                            formik={formik}
                                            text={"ثبت"}
                                        />
                                    </div>
                                </Form>
                            );
                        }}
                    </Formik>
                ) : (
                    <p>{rowData.manager_description ? rowData.manager_description : "توضیحاتی وجود ندارد"}</p>
                )
            }
        </ModalContainer>
        </>
    );
}

export default ManagerDetail;